export default {
  apply_fascia: "楣板申请",
  apply: "新增申请",
  applied_fascia: "已申请楣板信息",
  modify_fascia_deadline: "楣板修改截止时间：",
  fascia_config: "此处显示楣板备注",
  boothNo: "展位号",
  company_name: "公司名称",
  en_company_name: "公司英文名称",
  contactPerson: "联系人",
  phone: "联系电话",
  email: "电子邮箱",
  address: "地址",
  apply_date: "申请时间",
  action: "操作",
  modify_fascia: "修改",
  cn_company_name: "公司中文名",
  form_title: "填写楣板信息",
  form_tips: "若系统未查询到展位号，请与工作人员确认。",
  form_save: "保存",
  form_cancel: "取消",
  form_boothNo_check: "请输入展位号",
  form_cn_company_name_check: "请输入公司中文名",
  form_en_company_name_placeholder: "请输入公司英文名",
  form_address_placeholder: "请输入地址",
  form_contactPerson_check: "请输入联系人",
  form_phone_placeholder: "请输入联系电话",
  form_phone_check: "请输入正确的手机号码",
  form_email_placeholder: "请输入电子邮箱",
  form_email_check: "请输入正确的电子邮箱",
  loding: "加载中...",
  action_success: "操作成功！",
  request_error: "请求数据失败！",
  save_error_title: "操作失败",
  save_error: "中文公司名称和英文公司名称必须填写一项",
  仅特装可申请楣板: "仅特装可申请楣板",
  仅标摊展位可申请楣板: "仅标摊展位可申请楣板",
  展位号不存在: "展位号不存在"
};



// WEBPACK FOOTER //
// ./src/i18n/zh-cn/fascia.js